import React from 'react'
import { Dropdown } from 'react-bootstrap'

const DropDown = ({ title, list, onSelect, defaultValue }) => {
    return (
        <>
            <Dropdown >
                <Dropdown.Toggle variant="" id="dropdown-basic" className='text-white'>
                    {defaultValue ? defaultValue : (title || "Dropdown")}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {
                        list?.map((item, index) => {
                            return (
                                <Dropdown.Item key={index} onClick={() => onSelect(item)}>{item}</Dropdown.Item>
                            )
                        })
                    }
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default DropDown